/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Zapisywanie błędów javascript
 *
 * @export
 * @class ErrorsLogger
 */
export class ErrorsLogger {
	constructor() {
		var that = this;
		this.loggerUrl = 'https://'+window.location.hostname+'/info/common/saveJsErrors.php';
		this.sentSingleErrorAfterPageLoad = true; // true => zawsze wysyla pojedyncze zapisy (dokladniejsze)
		this.errorsCounter = 0;
		this.errors = new Object();

		window.onerror = function myErrorHandler(err, url, line) {
			return that.addError(err, url, line);
		};
		window.onload = function(){
			that.sentSingleErrorAfterPageLoad = true; // wymuszenie po evencie window load

			that.sendErrors();
		};
	}

	addError (err, url, line){
		var that = this;
		that.errorsCounter++;

		let timezone = (new Date()).getTimezoneOffset()/60;
		let timeOpened = new Date(Date.now() - (timezone*60*60*1000));

		var error = {
			id: that.errorsCounter,
			localTime: timeOpened.toISOString().split('.')[0].replace('T',' '),
			path: window.location.href,
			refferer: document.referrer,
			data: {
				err: err,
				url: url,
				line: line
			},
			info: {
				sid: I_SID,
				ident: I_ID,
				type: I_TYPE
			}
		};

		if ( that.sentSingleErrorAfterPageLoad ) {
			that.errors = new Object();
			that.errors['err'+that.errorsCounter] = error;
			that.sendErrors();
		} else {
			that.errors['err'+that.errorsCounter] = error;
		}

		return false; // true => nie pokazuje bledu w consoli
	}

	addCustomError (err, method){
		var that = this;
		if ( CFG_TEST )
			console.error('[TEST CUSTOM]', err,'->', method);
		that.addError('[custom] '+err,pageObj.getInfo.getFullPageURL(), method);
	}

	sendErrors(){
		var that = this;

		if ( Object.keys(that.errors).length > 0 && that.errors.constructor === Object ) {
			const xhr = new XMLHttpRequest();
			xhr.open("POST", that.loggerUrl, true);
			xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
			xhr.send(JSON.stringify(that.errors));
		}
	}
}